export const EVENTS = {
  TRANSACTION_FINISHED: 'transactionFinished'
};
